var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopStep133(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 632,
    viewBox: "0 0 320 632",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M151.586 7.29289C151.196 7.68342 151.196 8.31658 151.586 8.70711L157.95 15.0711C158.341 15.4616 158.974 15.4616 159.364 15.0711C159.755 14.6805 159.755 14.0474 159.364 13.6569L153.707 8L159.364 2.34315C159.755 1.95262 159.755 1.31946 159.364 0.928932C158.974 0.538408 158.341 0.538408 157.95 0.928932L151.586 7.29289ZM309 630H0V632H309V630ZM320 621V18H318V621H320ZM309 7H152.293V9H309V7ZM320 18C320 11.9249 315.075 7 309 7V9C313.971 9 318 13.0294 318 18H320ZM309 632C315.075 632 320 627.075 320 621H318C318 625.971 313.971 630 309 630V632Z",
    fill: "#134046"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopStep133);
export default __webpack_public_path__ + "static/media/laptop_step_13_3.fbc7b4e937cb5e760ebca6facb34205f.svg";
export { ForwardRef as ReactComponent };